/** Quote one CSV cell and keep untrusted text from becoming a spreadsheet formula.
 * Values retain their types until this boundary: numeric negatives stay numeric,
 * while formula-looking strings (including numeric-looking text) stay text.
 */
export const CSV_FORMULA_PREFIX = /^[\s\p{Cc}]*[=+@-]|^[\t\r\n]/u;

export function csvCell(value: unknown, missing: unknown = ''): string {
  const resolved = value ?? missing;
  const text = typeof resolved === 'object' && resolved !== null ? JSON.stringify(resolved) : String(resolved);
  const formulaText = typeof resolved === 'string' && CSV_FORMULA_PREFIX.test(text);
  return '"' + (formulaText ? "'" + text : text).replace(/"/g, '""') + '"';
}
